import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MemberAuthViewModel } from '../member-auth-view-model';
import { ConfirmMemberRequest } from '../../../../../../models/users/requests/confirm-member-request';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { emailValidator } from '../../../../../../validators/email.validator';
import { passwordComplexityValidator } from '../../../../../../validators/password-complexity.validator';
import { fieldMatchValidator } from '../../../../../../validators/field-match.validator';
import { EmailInputComponent } from '../../../../../../ui/form-components/email-input/email-input/email-input.component';

@Component({
  selector: 'app-member-setup',
  templateUrl: './member-setup.component.html',
  styleUrls: ['./member-setup.component.scss', '../../auth.component.scss']
})
export class MemberSetupComponent implements AfterViewInit {
  private viewModel = inject(MemberAuthViewModel);

  @ViewChild('emailInput', { static: true }) emailInput!: EmailInputComponent;

  public authFlowTitle$ = this.viewModel.authFlowTitle$;
  public authFlowSubtext$ = this.viewModel.authFlowSubtext$;

  public formSubmitted = false;

  public formGroup = new FormGroup(
    {
      email: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, emailValidator]
      }),
      password: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, passwordComplexityValidator]
      }),
      confirmPassword: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      eulaAccepted: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.requiredTrue]
      })
    },
    { validators: fieldMatchValidator('password', 'confirmPassword') }
  );

  public customErrorMessages = {
    email: {
      required: $localize`Email is required`,
      invalidEmail: $localize`Invalid email address`
    },
    password: {
      required: $localize`Password is required`,
      passwordComplexity: $localize`Password does not meet requirements`
    },
    confirmPassword: {
      required: $localize`Confirm password is required`,
      fieldsMustMatch: $localize`Passwords do not match`
    },
    eulaAccepted: {
      required: $localize`Terms and Conditions must be accepted in order to continue`
    }
  };

  public ngAfterViewInit(): void {
    this.emailInput.input.nativeElement.focus();
  }

  public confirmMember(): void {
    this.formSubmitted = true;
    if (!this.formGroup.valid) return;
    const { email, password, eulaAccepted } = this.formGroup.getRawValue();
    const req = new ConfirmMemberRequest(email, password, eulaAccepted);
    this.viewModel.confirmMember(req);
  }

  public openContactPage(): void {
    this.viewModel.openContactPage();
  }

  public openEulaModal(): void {
    this.viewModel.openEulaModal();
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
